var map = {
	"./chat": "./store/chat.js",
	"./chat.js": "./store/chat.js",
	"./crud": "./store/crud.js",
	"./crud.js": "./store/crud.js",
	"./list": "./store/list.js",
	"./list.js": "./store/list.js",
	"./oauth/login": "./store/oauth/login.js",
	"./oauth/login.js": "./store/oauth/login.js",
	"./push": "./store/push.js",
	"./push.js": "./store/push.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./store recursive ^\\.\\/.*$";


//////////////////
// WEBPACK FOOTER
// ./store ^\.\/.*$
// module id = ./store recursive ^\.\/.*$
// module chunks = 26